<template>
  <global-modal name="feedback-modal" @before-open="beforeOpen">
    <Modal @close="$modal.hide('feedback-modal')">
      <section class="feedback-modal">
        <h1 class="feedback-modal__title-main">{{ $t("feedback.title") }}</h1>

        <p class="text-error" v-if="errorMessage">{{ errorMessage }}</p>

        <div class="feedback-modal__row">
          <div class="feedback-modal__row-col">
            <InputLabel>
              <template #label> {{ $t("feedback.nameField") }} * </template>

              <input
                type="text"
                v-model="name"
                name="name"
                v-validate="'required'"
                :disabled="isSubmitting"
              />

              <template slot="error" v-if="errors.has('name')">
                {{ errors.first("name") }}
              </template>
            </InputLabel>
          </div>

          <div class="feedback-modal__row-col" v-if="isCallback">
            <InputLabel>
              <template #label> {{ $t("feedback.phoneField") }} * </template>

              <input
                type="text"
                v-model="phone"
                name="phone"
                v-validate="'required|phone'"
                :disabled="isSubmitting"
                v-mask="'+##################'"
                placeholder="+7 900 000 00 00"
              />

              <template slot="error" v-if="errors.has('phone')">
                {{ errors.first("phone") }}
              </template>
            </InputLabel>
          </div>

          <div class="feedback-modal__row-col" v-else>
            <InputLabel>
              <template #label>
                E-mail *
              </template>

              <input
                type="text"
                v-model="email"
                name="email"
                v-validate="'required|email'"
                :disabled="isSubmitting"
              />

              <template slot="error" v-if="errors.has('email')">
                {{ errors.first("email") }}
              </template>
            </InputLabel>
          </div>
        </div>

        <div class="feedback-modal__row">
          <div style="width: 100%">
            <InputLabel>
              <template #label> {{ $t("feedback.messageField") }} * </template>

              <textarea
                name="message"
                v-model="message"
                v-validate="'required'"
                class="input textarea"
                :disabled="isSubmitting"
              ></textarea>

              <template slot="error" v-if="errors.has('message')">
                {{ errors.first("message") }}
              </template>
            </InputLabel>
          </div>
        </div>

        <div class="feedback-modal__row">
          <PrimaryButton
            @click.prevent="validate"
            v-if="!successMessage"
            :disabled="isSubmitting"
          >
            {{ $t("feedback.send") }}
          </PrimaryButton>

          <PrimaryButton v-if="successMessage">
            {{ $t("feedback.sentSuccess") }}
          </PrimaryButton>
        </div>
      </section>
    </Modal>
  </global-modal>
</template>

<script>
import { mapState } from "vuex";
import apiUser from "@/api/user";
import Modal from "@/components/Modal/Modal.vue";
import { PrimaryButton, InputLabel } from "@v2/shared/ui/components";
import getError from "@/helpers/error";
export default {
  name: "FeedbackModal",

  components: {
    Modal,
    InputLabel,
    PrimaryButton
  },

  data() {
    return {
      isCallback: false,

      name: "",
      email: "",
      phone: "",
      message: "",

      isSubmitting: false,
      successMessage: false,
      errorMessage: ""
    };
  },

  computed: {
    ...mapState("auth", ["user"])
  },

  methods: {
    getError,
    validate() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }

        this.isSubmitting = true;

        const data = {
          name: this.name,
          message: this.message
        };

        if (this.isCallback) {
          data.phone = this.phone;
        } else {
          data.email = this.email;
        }

        apiUser
          .feedback(data)
          .then(() => {
            this.name = "";
            this.email = "";
            this.phone = "";
            this.message = "";

            this.$validator.reset();

            this.successMessage = true;

            setTimeout(() => {
              this.successMessage = false;
            }, 3000);
          })
          .catch(err => {
            this.errorMessage = getError(err);

            setTimeout(() => {
              this.errorMessage = "";
            }, 3000);
          })
          .finally(() => {
            this.isSubmitting = false;
          });
      });
    },

    beforeOpen(event) {
      this.isCallback = event.params && event.params.phone;

      this.name = this.user && this.user.name ? this.user.name : "";
      this.email = this.user && this.user.email ? this.user.email : "";
      this.message = "";
      this.phone = this.user && this.user.phone ? this.user.phone : "";

      this.successMessage = false;
      this.errorMessage = "";

      this.isSubmitting = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.feedback-modal {
  padding: 55px 170px 65px 80px;

  max-width: 780px;
  width: 100%;

  position: relative;
  z-index: 3;

  background: #fff;

  @include respond-down(lg) {
    padding: 47px 24px 64px 24px;
    box-sizing: border-box;
  }

  @include respond-down(md) {
    padding: 24px 16px 32px 16px;
    box-sizing: border-box;
  }

  &__title {
    &-main {
      @include h1();

      margin-bottom: 20px;

      @include respond-down(md) {
        max-width: 180px;
      }
    }
  }

  &__row {
    display: flex;
    justify-content: space-between;
    margin-top: 32px;

    @include respond-down(md) {
      flex-wrap: wrap;
      margin-top: 10px;
    }

    &-col {
      width: 380px;

      @include respond-down(lg) {
        width: 350px;
        margin-right: 10px;
      }

      @include respond-down(md) {
        width: 100%;

        margin-bottom: 16px;
      }
    }

    .textarea {
      width: 100%;
      min-height: 300px;

      resize: vertical;
    }
  }
}
</style>
